import { api } from "../api";


const BASE_URL = "/system-admin/shift-codes";

export const getShiftById = (id) => {
  return api.get(`${BASE_URL}/${id}`);
};
